const UploadIcon = (props: any) => (
    <svg width={40} height={41} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <rect y={0.5} width={40} height={40} rx={20} fill="#2BB792" />
        <path
            d="M18 24.5h4c.55 0 1-.45 1-1v-5h1.59c.89 0 1.34-1.08.71-1.71l-4.59-4.59a.996.996 0 0 0-1.41 0l-4.59 4.59c-.63.63-.19 1.71.7 1.71H17v5c0 .55.45 1 1 1Zm-4 2h12c.55 0 1 .45 1 1s-.45 1-1 1H14c-.55 0-1-.45-1-1s.45-1 1-1Z"
            fill="#fff"
        />
    </svg>
)

export default UploadIcon
